import { CommonCdcEnabelService } from '../features/services/common-cdcEnabled.service';

export class CDCConstants {
  static gigyaApiKey;
  public static rbaPolicy = 'hisense_mfa_gauth';
  public static EuDataCenter = 'https://cdns.eu1.gigya.com/js/gigya.js?apikey=';
  public static emptyPhoneNo = '0000000000';
  public static phoneNumberField = 'profile.phones.number';
  public static postalCodeField = 'data.addresses[0].postalCode';

  constructor(private commonService: CommonCdcEnabelService) {
    this.commonService.apiKey$.pipe().subscribe((apiKey) => (CDCConstants.gigyaApiKey = apiKey));
  }
}
